import React, { useState } from "react";

import toast from "react-hot-toast";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import { updateLeave } from "../../api/services/hroneApi";
import {
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
  StyledTextarea,
} from "../../StyledCss/styledInputs";
import { ErrorText } from "../../StyledCss/styledComponents";

const LeaveCancelForm = ({
  setIsLeaveCancelModalOpen,
  activeCancelId,
  getUserLeaves,
  requestType,
  closeBtn,
}) => {
  const [cancelReason, setcancelReason] = useState("");
  const [leaveReasonErr, setLeaveReasonErr] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const notifyLeaveCancel = () => {
    toast.success(`${requestType} Cancelled successfully`);
  };
  const notifyLeaveCancelFailed = () =>
    toast.error("Error while cancelling an leave");

  const cancelLeave = async (event) => {
    event.preventDefault();

    if (cancelReason.trim() === "") {
      setLeaveReasonErr(true);
    }
    if (cancelReason.trim() !== "") {
      try {
        const response = await updateLeave(
          "Cancelled",
          activeCancelId,
          cancelReason
        );

        if (response.ok) {
          getUserLeaves();
          setIsLeaveCancelModalOpen(false);
          notifyLeaveCancel();
          setcancelReason("");
          setLeaveReasonErr(false);
        }
      } catch (error) {
        notifyLeaveCancelFailed();
        setIsLeaveCancelModalOpen(false);
        setcancelReason("");
        setLeaveReasonErr(false);
      }
    }
  };

  return (
    <form autoComplete="off" onSubmit={cancelLeave}>
      {/* <div>
        <label htmlFor="reason">Reason for cancel:</label>
        <textarea
          onChange={(e) => {
            setcancelReason(e.target.value);
            setLeaveReasonErr("");
          }}
          value={cancelReason}
          id="reason"
          className=" form-control cancel-input"
          type="text"
        />
        {leaveReasonErr && <p className="text-danger">{leaveReasonErr}</p>}
      </div> */}
      <StyledInputGroup>
        <StyledInputContainer>
          <StyledTextarea
            onChange={(e) => {
              const reason = e.target.value;
              setcancelReason(reason);
              setErrorMsg(reason.length > 500 ? "Reason cannot exceed 500 characters." : "");
              if (reason) {
                setLeaveReasonErr(false);
              } else {
                setLeaveReasonErr(true);
              }
            }}
            value={cancelReason}
            id="reason"
            // className=" form-control cancel-input"
            type="text"
          />
          <StyledLabel hasValue={true} className="user-label">
            Reason*
          </StyledLabel>
        </StyledInputContainer>
      </StyledInputGroup>
      {errorMsg && (
        <ErrorText className="mt-3">*{errorMsg}</ErrorText>
      )}

      <div className="d-flex justify-content-end mt-3 gap-3">
        <SecondaryButton onClick={closeBtn}>Cancel</SecondaryButton>
        <PrimaryButton
          disabled={leaveReasonErr || !!errorMsg}
          type="button"
          onClick={cancelLeave}
        >
          Submit
        </PrimaryButton>
      </div>
    </form>
  );
};

export default LeaveCancelForm;
